import { AxiosResponse } from 'axios';
import reverse from 'django-reverse';
import axios from 'axios';
import { URLS } from './URLS';

export const editorCheckLayout = async (payload): Promise<AxiosResponse<any>> =>
	await axios.post(reverse(URLS.EDITOR_CHECK_LAYOUT), payload);
